import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block position-absolute h-4px top-0 end-0 start-0 bg-primary translate rounded" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "ms-n5 pb-2 fs-5" }, "Notifications", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator ms-n5 m-0" }, null, -1)
const _hoisted_5 = { class: "col-12 px-0" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "d-flex fs-6 fw-semibold align-items-center my-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "bullet bg-muted me-3",
  style: {"border-radius":"3px","width":"12px","height":"12px"}
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-gray-600 me-5" }, "Events:", -1)
const _hoisted_10 = { class: "ms-auto fw-bolder text-dark-700 text-end fs-7" }
const _hoisted_11 = { class: "d-flex fs-7 fw-semibold align-items-center my-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "bullet bg-muted me-3",
  style: {"border-radius":"3px","width":"12px","height":"12px"}
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-gray-600 me-5" }, "Uploads:", -1)
const _hoisted_14 = { class: "ms-auto fw-bolder text-dark text-end fs-7" }
const _hoisted_15 = { class: "d-flex fs-7 fw-semibold align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "bullet bg-dark me-3",
  style: {"border-radius":"3px","width":"12px","height":"12px"}
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-gray-600 me-5" }, "Actions:", -1)
const _hoisted_18 = { class: "ms-auto fw-bolder text-dark text-end fs-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[_ctx.widgetClasses, `bg-light-${_ctx.color}`], "card mt-5"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.eventCount), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.uploadCount), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.actionCount), 1)
          ])
        ])
      ])
    ])
  ], 2))
}